import { TOKEN_KEY, LOGIN_KEY } from "~/stores/translationBackends/HttpBackend";
import { useIdentity } from "~/composables/useIdentity";

// Consume the NR handoff token from the URL fragment (#nrt=...) on app load:
// exchange it for a session token, keep it in localStorage, strip the fragment.
export default defineNuxtPlugin((nuxtApp) => {
  const match = window.location.hash.match(/[#&]nrt=([^&]+)/);
  if (!match) return;

  // Strip after mount — the router re-applies the URL it captured (hash
  // included) when it settles after hydration, undoing an earlier strip
  nuxtApp.hook("app:mounted", () => {
    history.replaceState(null, "", window.location.pathname + window.location.search);
  });

  fetch("/api/auth/exchange", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token: match[1] }),
  })
    .then((resp) => (resp.ok ? resp.json() : null))
    .then((data) => {
      if (data?.token) {
        localStorage.setItem(TOKEN_KEY, data.token);
        localStorage.setItem(LOGIN_KEY, data.login);
        useIdentity().refresh();
      } else {
        console.warn("NR handoff token expired or invalid — continuing anonymously");
      }
    })
    .catch(() => {});
});
